import React from "react";
import { User } from "lucide-react";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_procurement-hub-215/artifacts/5wtlks8a_Somcore%20-%20Logo.png";

export default function AuthShell({ panelTitle, panelText, eyebrow, title, subtitle, children, footer }) {
  React.useEffect(() => { document.title = `${title || "Account"} · Somcore Hub`; }, [title]);
  return (
    <div className="grid min-h-screen lg:grid-cols-2 bg-[#F1F3F6]">
      <div className="relative hidden overflow-hidden bg-[#122E5C] lg:flex lg:flex-col lg:items-center lg:justify-center">
        <div className="pointer-events-none absolute -top-20 right-10 h-72 w-72 rounded-full bg-white/5" />
        <div className="pointer-events-none absolute top-1/3 -right-16 h-40 w-40 rounded-full bg-white/5" />
        <div className="pointer-events-none absolute -bottom-24 -left-16 h-80 w-80 rounded-full bg-white/[0.04]" />
        <div className="pointer-events-none absolute bottom-24 left-24 h-24 w-24 rounded-full bg-white/[0.04]" />
        <div className="relative z-10 flex flex-col items-center px-12 text-center text-white">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20">
            <User className="h-9 w-9 text-white" />
          </div>
          <h1 className="mt-8 font-heading text-4xl font-bold tracking-tight">{panelTitle}</h1>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-300">{panelText}</p>
          <img src="/somcore-logo-white.png" alt="Somcore" className="mt-12 ml-8 h-20 w-auto opacity-95" />
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-[0_10px_40px_-15px_rgba(18,46,92,0.25)]">
          <div className="flex flex-col items-center text-center">
            <img src={LOGO} alt="Somcore" className="h-10 w-auto" />
            <div className="mt-6 text-xs font-semibold tracking-wide text-primary">{eyebrow}</div>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-slate-900">{title}</h2>
            <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
          </div>
          {children}
          {footer}
          <p className="mt-6 text-center text-xs text-muted-foreground">At the Core of Global Resources.</p>
        </div>
      </div>
    </div>
  );
}
